import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	provideDetails: {
		id: 'redesign.purhcase.creditCardForm.provideDetails',
		defaultMessage: 'Provide your details',
		description: 'Header above the form where they purchase gift cards',
	},
});
